import CryptoJS from "crypto-js";
import { confirmAction, getTenantId, hasMemberPermission, notifySuccess, openMemberLimit } from "@/api/runtime";

/** 旧控制台静态资源根路径。 */
const CDN_URL = "https://static.zhihaoscm.cn/";

/** 组织认证授权委托书模板，路径与旧 utils/config.ts 的 PowerAttorneyFileName 一致。 */
export const POWER_ATTORNEY_FILE_URL = `${CDN_URL}template/%E6%8E%88%E6%9D%83%E5%A7%94%E6%89%98%E4%B9%A6%E6%A8%A1%E6%9D%BF.docx`;

/** 海康视频播放器地址模板，字段占位符保持旧项目格式。 */
export const VideoPlayerUrl = `${import.meta.env.VITE_VIDEO_PLAYER_URL}?{dateRange}token={token}&deviceSerial={deviceSerial}&mode={mode}&origin={origin}`;

/** 使用与 Vue 完全相同的 AES/ECB/PKCS7 数据解密合同。 */
export function decryptData(data: string) {
    const keyHex = CryptoJS.enc.Utf8.parse("1234567891234567");
    return JSON.parse(CryptoJS.AES.decrypt(data, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8));
}

/** 会员权限由应用运行时注入，API 层不直接依赖 Zustand。 */
export function validateMemberPermission(permission: string) { return hasMemberPermission(permission); }

/** 保持旧控制台会员遮罩图资源路径。 */
export function getPublicFileUrl(path: string) { return `${CDN_URL}customer-admin/${path}`; }

/** 会员限制弹窗由 React UI 运行时接管。 */
export const memberLimitDialog = {
    open: (options?: { blurImg?: string[] | string }) => openMemberLimit(options)
};

/** 复合状态的高 16 位是旧业务使用的正常状态。 */
export const analysisState = {
    getNormalState: (state: number) => (state >> 16) & 0xffff
};

/** 租户为空表示链云主租户，保持 Vue Tenant.isChainCloud 规则。 */
export function isChainCloudTenant() { return !getTenantId(); }

type ConfirmableOptions = {
    switchParamIndex?: number;
    msgs: [string, string];
    completedMsgs?: [string, string];
    switchParamFiled?: string;
};

type Decorator = (target: object, propertyKey: string, descriptor: PropertyDescriptor) => void;

/** 保留旧服务装饰器的确认时机与完成提示，不把 UI 库耦合进 API。 */
export function confirmable(options: ConfirmableOptions): Decorator;
export function confirmable(message: string, completedMessage?: string): Decorator;
export function confirmable(message: string | ConfirmableOptions, completedMessage?: string): Decorator {
    return (_target, _propertyKey, descriptor) => {
        const original = descriptor.value as (...args: any[]) => Promise<any>;
        descriptor.value = async function (...args: any[]) {
            const options = typeof message === "string" ? undefined : message;
            const switchIndex = options?.switchParamIndex ?? args.length - 1;
            const switchValue = options?.switchParamFiled
                ? args[switchIndex]?.[options.switchParamFiled]
                : args[switchIndex];
            const confirmMessage = typeof message === "string" ? message : options!.msgs[switchValue];
            const successMessage = typeof message === "string"
                ? completedMessage
                : options!.completedMsgs?.[switchValue];
            await confirmAction(confirmMessage);
            const result = await original.apply(this, args);
            const fallback = /是否(.{2})/.exec(confirmMessage)?.at(1)?.replace(/^/, "已");
            if (successMessage ?? fallback) notifySuccess(successMessage ?? fallback!);
            return result;
        };
    };
}
